/** Explore filters, kept in the URL. */
export interface ExploreSearch {
  symbol?: string;
  kind?: "equity" | "futures" | "options";
  ra?: number;
  city?: string;
  min_hit_rate?: number;
}

export function parseExploreSearch(s: Record<string, unknown>): ExploreSearch {
  const str = (v: unknown) =>
    typeof v === "string" && v.trim() ? v.trim().slice(0, 60) : undefined;
  const num = (v: unknown) => {
    const n =
      typeof v === "number" ? v : typeof v === "string" ? Number(v) : NaN;
    return Number.isFinite(n) ? n : undefined;
  };
  const kind = str(s.kind);
  return {
    symbol: str(s.symbol)?.toUpperCase(),
    kind:
      kind === "equity" || kind === "futures" || kind === "options"
        ? kind
        : undefined,
    ra: num(s.ra),
    city: str(s.city),
    min_hit_rate: num(s.min_hit_rate),
  };
}
